import { CaretRightOutlined, RightOutlined, PrinterOutlined, EyeOutlined, CheckCircleTwoTone } from "@ant-design/icons";
import {
  Collapse,
  Row,
  Col,
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  Alert,
  notification,
  Typography,
  Space,
  Spin,
  Card,
  Avatar,
  Descriptions,
  Modal
} from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';

import memberService from "../../../api/member.service";
import ProgrammeCommercialService from "../../../api/programme.commercial.service";
import ProgrammeService from "../../../api/programme.service";

import timeSlotService from "../../../api/time.slot.service";

import {
  DATE_FORMAT_DMY_SLASH,
  MEMBER_ACCOUNT_ID,
  ROUND_OFF_ACCOUNT_ID,
  SAVE_SUCCESS_MSG,
  SUCCESS_STATUS,
  BANK_CHARGES_ACCOUNT_ID,
  PAYMENT_SECTION_REQUIRED_MESSAGE,
  ADD_ONE_PAYMENT_MODE,
  EDIT_MODE,
  JCP_PROGRAM_ID,
} from "../../../utility/Constants";

import TimeSlotEnrollment from "../TimeSlotEnrollment";
import moment from "moment";
import enrollmentService from "../../../api/enrollment.service";
import commonUtility from "../../../utility/Utils";
import EnrollmentComponent from "../commercial-components/EnrollmentComponent";
import accountService from "../../../api/account.service";
import OtherItems from "../commercial-components/OtherItems";
import TestFormItem from "../commercial-components/TestFormItem";
import PaymentComponent from "../commercial-components/PaymentComponent";
import paymentService from "../../../api/payment.service";
import StudentCardInfo from "../../common/StudentCardInfo";
import { useSelector } from "react-redux";
import ModalWithMessageAndAction from "../../common/ModalWithMessageAndAction";
import { PRINT_BASE_URL } from "../../../utility/URL";
import ReceiptHistoryComponent from "../ReceiptHistoryComponent";
const { Panel } = Collapse;
const { Option } = Select;
const { TextArea } = Input;
const { Text } = Typography;


const defaultFormValues = {
  mode: "ADD",
  enrollment_id: 0,
  member_id: 0,
  programme_id: 0,
  group_id: "",
  voucher_id: 0,
  date_of_join: null,
  enrollment_start_date: null,
  enrollment_end_date: null,
  dr_ac_id: "",
  student_account_id: MEMBER_ACCOUNT_ID,
  member_opening_balance: 0,
  receipt_id: 0,
  receipt_no: "",
  last_paid_date: "",
  receipt_date: null,
  is_payment_done: "N",
  no_of_months: 0,
  entry_from: "M",
  adjust_amount: 0,
  adjust_receipt_id: 0,
  round_off_amount: 0,
  round_off_account_id: ROUND_OFF_ACCOUNT_ID,
  total_bank_charges: 0,
  bank_charges_account_id: BANK_CHARGES_ACCOUNT_ID,
  // day_slot: [],
  component_details_admission: [],
  component_details_monthly: [],
  component_details_others: [],
  is_wave_receipt: "N",
};



const JcpEnrollmentEntryMonthly = () => {
  const [form] = Form.useForm();

  const params = useParams();
  let navigate = useNavigate();

  const state = useSelector((state) => state.otheritem)


  const [isMemberEditable, setIsMemberEditable] = useState(true);
  const [enrollmentID, setEnrollmentID] = useState(0);
  const [receiptID, setReceiptID] = useState(0);
  const [paymentID, setPaymentID] = useState(0);
  const [memberID, setMemberID] = useState(0);
  const [billType, setBillType] = useState("");
  const [isGSTBill, setGSTBillType] = useState("");
  const [printURL, setPrintURL] = useState("");


  const [programmeGroupList, setProgrammeGroupList] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [isAlreadyMemberEnrolled, setIsAlreadyMemberEnrolled] = useState(false);
  const [alreadyMemberEnrolledMessage, setAlreadyMemberEnrolledMessage] =
    useState("");

  const [isAdmissionComponentRender, setIsAdmissionComponentRender] = useState(false);
  const [progCommercialCompAdmissionList, setProgCommercialCompAdmissionList] =
    useState([]);


  const [progCommercialCompMonthlyList, setProgCommercialCompMonthlyList] =
    useState([]);
  

  const [progCommercialCompOtherList, setProgCommercialCompOtherList] =
    useState([]);
  const [progCommercialCompOtherListInitialValue, setProgCommercialCompOtherListInitialValue] =
    useState([]);



  const [programmeID, setProgrammeID] = useState([]);
  const [programmeGroupID, setProgrammeGroupID] = useState(0);

  const [monthlyComponentID, setMonthlyComponentID] = useState(0);
  const [monthlyComponentAmount, setMonthlyComponentAmount] = useState(0);

  // create a state for monthly component Show by dipten (12.02.2025)
  const [monthlyComponentShow, setMonthlyComponentShow] = useState(true);
  
  const [monthlyComponentAccountID, setMonthlyComponentAccountID] = useState(0);
  const [monthlyComponentDesc, setMonthlyComponentDesc] = useState("");

  const [monthlyComponentCGSTID, setMonthlyComponentCGSTID] = useState(0);
  const [monthlyComponentCGSTRate, setMonthlyComponentCGSTRate] = useState(0);
  const [monthlyComponentSGSTID, setMonthlyComponentSGSTID] = useState(0);
  const [monthlyComponentSGSTRate, setMonthlyComponentSGSTRate] = useState(0);
  const [isParentEnrollment, setIsParentEnrollment] = useState("N");


  const [isMonthlyComponentRender, setIsMonthlyComponentRender] =
    useState(false);
  const [isOtherComponentRender, setIsOtherComponentRender] = useState(false);


  const [accountList, setAccountList] = useState([]);


  const [isFormChanged, setIsFormChanged] = useState(false);

  const [totalAmount, setTotalAmount] = useState(0);
  const [totalDiscountAmount, setTotalDiscountAmount] = useState(0);
  const [totalTaxableAmount, setTotalTaxableAmount] = useState(0);
  const [totalCGSTAmount, setTotalCGSTAmount] = useState(0);
  const [totalSGSTAmount, setTotalSGSTAmount] = useState(0);
  const [totalPayableAmount, setTotalPayableAmount] = useState(0);
  const [totalNetAmount, setTotalNetAmount] = useState(0);
  const [totalRoundOff, setTotalRoundOff] = useState(0);
  const [totalBankCharges, setTotalBankCharges] = useState(0);
  const [paidAmount, setPaidAmount] = useState(0);

  // Payment useState
  const [paymentPaidList, setPaymentPaidList] = useState([]);
  const [totalPaidAmount, setTotalPaidAmount] = useState(0);
  const [remainingAmount, setRemainingAmount] = useState(0);

  const [isSaveLoaderEnable, setSaveLoaderEnable] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [responseModalTitle, setResponseModalTitle] = useState("");
  const [responseModalMessage, setResponseModalMessage] = useState("");

  const [lastPaidMonthHistoryText, setLastPaidMonthHistoryText] = useState("");

  const [depositTrigger, setDepositTrigger] = useState(0);

  // member Info
  const [memberDisplayInfo, setMemberDisplayInfo] = useState({
    memberName: '',
    memberPrimaryMobile: '',
    memberFatherName: '',
    memberDOB: '',
    profilePic: '',

  })

  const [memberDisplayOtherInfo, setMemberDisplayOtherInfo] = useState({
    group: '',
    joinDate: '',
    validity: ''
  })

  const [shortAdjustmentData, setShortAdjustmentData] = useState({
    adjust_amount: 0,
    adjust_receipt_id: 0,
  });

  const [initialAmounts, setInitialAmounts] = useState([]);
  const [hasAmountChanged, setHasAmountChanged] = useState(false);
  const [setAcountId, setSetAcoundId] = useState(0);

  const [receiptHistoryList, setReceiptHistoryList] = useState([]);

  useEffect(() => {
    // Store initial amounts when the component mounts or when progCommercialCompMonthlyList changes
    if (progCommercialCompMonthlyList.length > 0) {
      // monthlyComponentGenerate();
      setInitialAmounts(progCommercialCompMonthlyList.map(item => item.amount));
    }
  }, [progCommercialCompMonthlyList]);

  const handleAmountChange = (updatedList) => {
    // Check if any of the months has a changed amount
    const amountsChanged = updatedList.some(item => item.isAmountDifferent);
    setHasAmountChanged(amountsChanged);
  };


  const onJCPenrollmentSave = async (values) => {
    console.log("values", values);

    // setSaveLoaderEnable(true)
    // e.preventDefault()
    let isWaveReceipt;
    if (values.payable_amount === 0) {
      isWaveReceipt = "Y";
    } else {
      isWaveReceipt = "N";
    }

    let totalDueAmount = values.payable_amount;
    let remainingPayableAmount = values.payable_amount;

    const updatedPaymentData = values.payment_data.map(item => {
      let dueAmount = 0;
      let paidAmount = Math.min(item.amount, remainingPayableAmount);

      if (remainingPayableAmount < item.amount) {
        dueAmount = item.amount - remainingPayableAmount;
        totalDueAmount += dueAmount;
      }

      remainingPayableAmount -= paidAmount;

      return {
        ...item,
        due_amount: dueAmount,
        is_due: dueAmount > 0 ? "Y" : "N",
      };
    });

    const data = {
      formdata: {
        ...values,
        is_wave_receipt: isWaveReceipt,
        payment_data: updatedPaymentData,
      }
    };
    // console.log("data", data);
    // return false;
    console.log("dataaaaaa", data);
    
    if (values.payment_data.length > 0) {
      setSaveLoaderEnable(true)

      enrollmentService.enrollmentJCPMonthlySave(data).then((res) => {
        if (isWaveReceipt === 'Y') {
          notification.error({
            message: 'No Reciept No. Generated',
            description: 'Reciept No. will not be generated against this transaction.',
            placement: 'bottom',
            style: { color: 'red' }
          });
        }
        if (
          res.data.response_data.enrolmentData &&
          res.data.response_data.enrolmentData.length > 0
        ) {

          /*
          notification.error({
            message: `Error`,
            description: "This member is already enrolled with this programme.",
            placement: "bottom",
          });
          */


        } else if (res.data.response_data.enrollment_id > 0) {
          const resp_data = res.data.response_data;
          // notification.success({
          //   message: `Success`,
          //   description: `${SAVE_SUCCESS_MSG} with enrollment id ${res.data.response_data.enrollment_id} and receipt number ${res.data.response_data.receipt_no}`,
          //   placement: "bottom",
          // });



          // const print_url = `${PRINT_BASE_URL}taxinvoice/receiptpdf/${resp_data.enrollment_id}/${resp_data.receipt_master_id}/${resp_data.payment_master_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0 }`
          // setPrintURL(print_url);

          setOpenModal(true)
          setResponseModalTitle("Sucess")
          setResponseModalMessage("Successfully Saved")

          // set responsing message after monthly payment by dipten (12.02.2025)
          if(res.data.response_data.receipt_no){
            setResponseModalMessage("Data saved successfully. Receipt No: "+res.data.response_data.receipt_no)
          }


          const print_url = `${PRINT_BASE_URL}taxinvoice/receiptpdf/${resp_data.enrollment_id}/${resp_data.receipt_master_id}/${resp_data.payment_master_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`
          setPrintURL(print_url);
        }
        setSaveLoaderEnable(false)
      });
    }
    else {
      commonUtility.openNotificationWithType("error", "bottomRight", "Error", ADD_ONE_PAYMENT_MODE);
    }
  };


  const onChangeCollapse = (key) => {
    console.log(key);
  };

  /*
  const onSelectProgrammeGroup = (value, event) => {
    setProgrammeGroupID(value);
    form.setFieldsValue({ day_slot: [] });

  };
  */

  const onChangeMonthlyMonth = (e, v) => {
    // if (commonUtility.sanitizeObject(form.getFieldValue("date_of_join"))) {
    //   setIsMonthlyComponentRender(false);
    //   const x = form.getFieldValue("no_of_months");
    //   const data = {
    //     formdata: { total_month: x, date_of_join: form.getFieldValue("date_of_join")  },
    //   };
    //   enrollmentService.programmeEnrollmentGenerateMonth(data).then((res) => {
    //     if (res.data.response_status === SUCCESS_STATUS) {
    //       console.log(res.data.response_data);
    //       setProgCommercialCompMonthlyList(res.data.response_data);
    //       setIsMonthlyComponentRender(true);
    //     }
    //   });
    // }
    // else{
    //   console.log("on else changeMonthly")
    // }

    removePayment();
    monthlyComponentGenerate();
  };




  // const monthlyComponentGenerate = () => {
  //   // console.log('form.getFieldValue("date_of_join")',form.getFieldValue("component_id"));
  //   if (commonUtility.sanitizeObject(form.getFieldValue("date_of_join"))) {
  //     setIsMonthlyComponentRender(false);
  //     setProgCommercialCompMonthlyList([]);
  //     const x = form.getFieldValue("no_of_months");
  //     // console.log("comp_id"+monthlyComponentID);
  //     const data = {
  //       formdata: { total_month: x, date_of_join: form.getFieldValue("date_of_join"), component_id: monthlyComponentID },
  //     };
  //     enrollmentService.programmeEnrollmentGenerateMonth(data).then((res) => {
  //       if (res.data.response_status === SUCCESS_STATUS) {
  //         const monthlyData = res.data.response_data;
  //         console.log("monthlyData", monthlyData);

  //         // Validation: Check if amounts are consistent across months
  //         let isAmountSame = true;
  //         let firstMonthAmount = monthlyData[0]?.amount;

  //         for (let i = 0; i < monthlyData.length; i++) {
  //           if (monthlyData[i]?.amount !== firstMonthAmount) {
  //             isAmountSame = false;
  //             break;
  //           }
  //         }

  //         if (!isAmountSame) {
  //           notification.error({
  //             message: "Payment Error",
  //             description: "Amounts for selected months are not consistent. Please check and try again.",
  //           });

  //           // Prevent further processing and reset the input field
  //           form.setFieldsValue({ no_of_months: '' });
  //           return;
  //         }

  //         setProgCommercialCompMonthlyList(monthlyData);
  //         setIsMonthlyComponentRender(true);
  //       }
  //     });
  //   }
  // }

  const monthlyComponentGenerate = () => {
    if (commonUtility.sanitizeObject(form.getFieldValue("date_of_join"))) {
      setIsMonthlyComponentRender(false);
      setProgCommercialCompMonthlyList([]);
      const x = form.getFieldValue("no_of_months");
      const data = {
        formdata: { total_month: x, date_of_join: form.getFieldValue("date_of_join"), component_id: monthlyComponentID },
      };
      let monthly_total_discount = form.getFieldValue("component_details_monthly");
      console.log("monthly_total_discount", monthly_total_discount);

      enrollmentService.programmeEnrollmentGenerateMonth(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          const monthlyData = res.data.response_data;
          console.log("monthlyData", monthlyData);

          // Determine the first month's amount
          const firstMonthAmount = monthlyData[0]?.amount;

          // Iterate through the data and add a flag if the amount is different from the first month
          const highlightedMonthlyData = monthlyData.map((month) => ({
            ...month,
            // isAmountDifferent: month.amount !== firstMonthAmount,
            isAmountDifferent: false,

          }));

          // Set the data to be displayed
          setProgCommercialCompMonthlyList(highlightedMonthlyData);
          //console.log("highlightedMonthlyData", highlightedMonthlyData);
          
          setIsMonthlyComponentRender(true);
        }
      });
    }
  };




  useEffect(() => {
    const rcpt_dt = commonUtility.dateFormatDDMMYYYY(new Date(), "/");
    form.setFieldsValue({
      receipt_date: rcpt_dt,
    });
  }, []);


  useEffect(() => {
    const data = {
      formdata: { short_code: "JCP" },
    };
    ProgrammeService.programmeByCode(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setProgrammeID(res.data.response_data[0].programme_id);
        form.setFieldsValue({
          programme_id: res.data.response_data[0].programme_id,
        });
      }
    });
  }, []);


  useEffect(() => {
    const data = {
      formdata: { programme_id: JCP_PROGRAM_ID },
    };
    memberService.memberListByProgramme(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setMemberList(res.data.response_data);
      }
    });
  }, [programmeID, memberID]);



  useEffect(() => {

    // if(form.getFieldValue('is_gst_bill') == "N"){
    if (billType != "" && billType == "nongst") {

      setMonthlyComponentID(0);
      setMonthlyComponentAmount(0);
      setMonthlyComponentDesc("");
      setMonthlyComponentAccountID(0);

      setMonthlyComponentCGSTID(0);
      setMonthlyComponentCGSTRate(0);
      setMonthlyComponentSGSTID(0);
      setMonthlyComponentSGSTRate(0);

      const data = {
        formdata: {
          //programme_id: form.getFieldValue('programme_id'),
          programme_id: JCP_PROGRAM_ID,
          component_type: "MONTHLY",
          group_id: form.getFieldValue('group_id'),
          is_gst_applicable: form.getFieldValue('is_gst_bill'),
        },
      };
      ProgrammeCommercialService.programmeCommercialByOptions(data).then(
        (res) => {
          if (res.data.response_status === SUCCESS_STATUS) {
            if (res.data.response_data.length > 0) {
              // console.log(form.getFieldValue('mode'));
              // console.log("CommercialCompMonthlyList", res.data.response_data);
              setMonthlyComponentID(res.data.response_data[0].component_id);
              setMonthlyComponentAmount(res.data.response_data[0].amount);
              setMonthlyComponentDesc(res.data.response_data[0].description);
              setMonthlyComponentAccountID(res.data.response_data[0].account_id);
              setProgCommercialCompMonthlyList(res.data.response_data);
              //console.log("res.data.response_data", res.data.response_data);
              
              setSetAcoundId(res.data.response_data[0].account_id);
              console.log("res.data.response_data", res.data.response_data);
              setDepositTrigger(res.data.response_data[0].is_security);
              console.log("***jcp***", res.data.response_data);

              //console.log("******",res.data.response_data[0].is_security);
              
              setMonthlyComponentCGSTID(commonUtility.sanitizeValue(res.data.response_data[0].cgst_id));
              setMonthlyComponentCGSTRate(commonUtility.sanitizeValue(res.data.response_data[0].cgst_rate));
              setMonthlyComponentSGSTID(commonUtility.sanitizeValue(res.data.response_data[0].sgst_id));
              setMonthlyComponentSGSTRate(commonUtility.sanitizeValue(res.data.response_data[0].sgst_rate));
              setIsMonthlyComponentRender(true);
              form.getFieldValue('mode') == "ADD" && monthlyComponentGenerate();


            }
          }
        }
      );
    }


  }, [programmeGroupID, billType]);



  const getAdmissionSecurityList = () => {
    //setIsLoaded(false);
    // console.log("first", lastDatePaid);
    // console.log("isPaidSecurityInfo", isPaidSecurityInfo);
    if (form.getFieldValue('is_gst_bill') == "N" && form.getFieldValue("last_paid_date") == "" && form.getFieldValue("is_security_paid") == "N") {
      // if (form.getFieldValue('is_gst_bill') == "N" && (lastDatePaid === "" && isPaidSecurityInfo === "N")) {

      const data = {
        formdata: {
          programme_id: JCP_PROGRAM_ID,
          component_type: "ADMISSION",
          //group_id: programmeGroupID,
          group_id: 0, //b Calling for Security Deposit 
          is_gst_applicable: 'N'
        },
      };

      ProgrammeCommercialService.programmeCommercialByOptions(data).then(
        (res) => {
          if (res.data.response_status === SUCCESS_STATUS) {
            setProgCommercialCompAdmissionList(res.data.response_data);
            setProgCommercialCompMonthlyList(res.data.response_data);
            setDepositTrigger(res.data.response_data[0].is_security);
            // console.log("+++++++",res.data.response_data[0].is_security);
            // console.log("Security Deposit", res.data.response_data);
            console.log("+++jcp+++", res.data.response_data);

            setIsAdmissionComponentRender(true);
          }
        }
      );



    }
    else {
      setProgCommercialCompAdmissionList([]);
      setIsAdmissionComponentRender(false);
    }

  }

  /*
  const getReceiptHistory = (enrollment_id) => {
    console.log('receiptHistory');
    setReceiptHistoryList([]);
      const data = {
        formdata: {
          enrollment_id: enrollment_id,
        },
      };
  
      memberService.receiptHistory(data).then(
        (res) => {
          if (res.data.response_status === SUCCESS_STATUS) {
            setReceiptHistoryList(res.data.response_data);
          }
        }
      );
  }

  useEffect(()=>{
    if(enrollmentID > 0){
      getReceiptHistory(enrollmentID);
    }
  },[enrollmentID]);
  */




  useEffect(() => {
    if (form.getFieldValue('mode') == "ADD") {
      let obj = [];
      progCommercialCompAdmissionList.map((e) => {
        let cgst_amount = 0;
        let sgst_amount = 0;
        let total_gst_amt = 0;
        let payable_amount = e.amount;

        if (e.cgst_rate > 0 && e.sgst_rate > 0 && e.amount > 0) {
          cgst_amount = (parseFloat(e.amount) * parseFloat(e.cgst_rate)) / 100;
          sgst_amount = (parseFloat(e.amount) * parseFloat(e.sgst_rate)) / 100;
          total_gst_amt = cgst_amount + sgst_amount;
          payable_amount = e.amount + total_gst_amt;
        }

        const x = {
          component_id: e.component_id,
          description: e.description,
          month_id: 0,
          year: 0,
          amount: e.amount,
          cr_ac_id: e.account_id,
          discount: 0,
          taxable_amount: e.amount,
          cgst_id: e.cgst_id,
          cgst_rate: e.cgst_rate,
          cgst_rate_text: commonUtility.sanitizeObject(e.cgst_rate) != "" ? `${e.cgst_rate}%` : '0%',
          cgst_amount: cgst_amount,
          sgst_id: e.sgst_id,
          sgst_rate: e.sgst_rate,
          sgst_rate_text: commonUtility.sanitizeObject(e.sgst_rate) != "" ? `${e.sgst_rate}%` : '0%',
          sgst_amount: sgst_amount,
          total_gst_amount: total_gst_amt,
          net_amount: payable_amount,
          is_due: 'N'
        };
        obj.push(x);
      });
      form.setFieldsValue({ component_details_admission: obj });
    }
    onFormCalculation();
  }, [isAdmissionComponentRender, monthlyComponentID]);



  const [isPaidSecurityInfo, setIsPaidSecurityInfo] = useState("");
  const [lastDatePaid, setLastDatePaid] = useState("");
  const [lastPaidMonth, setLastPaidMonth] = useState("");

  const onSelectMember = (value) => {
    if (form.getFieldValue('mode') == "ADD") {
      form.setFieldsValue({
        no_of_months: ""
      });
      monthlyComponentGenerate();
    }
    if (value > 0) {

      setIsAlreadyMemberEnrolled(false);
      setAlreadyMemberEnrolledMessage("");
      setLastPaidMonthHistoryText("");
      setMemberID(value);
      form.setFieldsValue({
        last_paid_date: ""
      });

      //  console.log(value);
      const data = { formdata: { member_id: value, programme_id: JCP_PROGRAM_ID } };
      //console.log("data", data);
      
      ProgrammeService.checkMemberEnrolement(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          const response = res.data.response_data;
          //console.log("responseData", response);
          setLastDatePaid(response.paymentData[0].last_paid_date);
          setIsPaidSecurityInfo(response.securityPayInfo[0].is_security_paid);
          setLastPaidMonth(response.enrolmentData[0].last_paid_month);

          form.setFieldsValue({
            member_id: response.memberData[0].member_id,
            member_search: response.memberData[0].member_id,
            member_name:
              response.memberData[0].member_fname +
              " " +
              response.memberData[0].member_lname,
            member_primary_mobile: response.memberData[0].primary_mobile,
            member_father_name: response.memberData[0].father_name,
            date_of_birth: response.memberData[0].date_of_birth,
            group_id: response.enrolmentData[0].group_id,
            enrollment_id: response.enrolmentData[0].enrollment_id,
          });


          setMemberDisplayInfo({
            memberName: `${response.memberData[0].member_fname} ${response.memberData[0].member_lname}`,
            memberPrimaryMobile: response.memberData[0].primary_mobile,
            memberFatherName: response.memberData[0].father_name,
            memberDOB: response.memberData[0].date_of_birth,
            profilePic: response.memberData[0].profile_picture,
          });

          setMemberDisplayOtherInfo({
            group: response.enrolmentData[0].group_id === 1 ? 'Morning' : response.enrolmentData[0].group_id === 2 ? 'Afternoon' : 'Evening',
            joinDate: response.enrolmentData[0].enrollment_date,
            validity: `${response.enrolmentData[0].enrollment_start_date} to ${response.enrolmentData[0].enrollment_end_date}`
          });


          if (response.paymentData.length > 0) {

            form.setFieldsValue({
              date_of_join: response?.paymentData[0]?.nexy_pay_month
            });

            setLastPaidMonthHistoryText(response?.paymentData[0]?.last_paid_date)
            form.setFieldsValue({
              last_paid_date: response?.paymentData[0]?.last_paid_date,
              is_security_paid: response.securityPayInfo[0].is_security_paid
            });

          }
          else {

            form.setFieldsValue({
              date_of_join: response?.enrolmentData[0]?.enrollment_date
            });
          }


          setEnrollmentID(response.enrolmentData[0].enrollment_id)
          setProgrammeGroupID(response.enrolmentData[0].group_id)

          if (response.enrolmentData[0].enrolled_from !== "PROMOTED") {
            getAdmissionSecurityList();
          }

          console.log("last_paid_month",commonUtility.checkEmpty(response.enrolmentData[0].last_paid_month))

          // update monthly component show according response data by dipten (12.02.2025)
          if(response.securityPayInfo[0].is_security_paid==="N" && commonUtility.sanitizeObject(response.enrolmentData[0].last_paid_month) === "" && commonUtility.sanitizeObject(response.paymentData[0].last_paid_date) === ""){
            console.log("if")
            setMonthlyComponentShow(false);
          }else{
            console.log("else")
            setMonthlyComponentShow(true);
          }

          if (response.enrolmentData[0].parent_enrollment_id > 0) {
            setIsParentEnrollment("Y");
          } else {
            setIsParentEnrollment("N");
          }
          //getReceiptHistory(response.enrolmentData[0].enrollment_id);

          if (response?.shortExcessData) {
            // console.log('response.shortExcessData.adjust_amount', response.shortExcessData.adjust_amount);
            form.setFieldsValue({
              adjust_receipt_id: response.shortExcessData.adjust_receipt_id,
              adjust_amount: response.shortExcessData.adjust_amount,
            });

            setShortAdjustmentData({
              adjust_receipt_id: response.shortExcessData.adjust_receipt_id,
              adjust_amount: response.shortExcessData.adjust_amount,
            });
          }
        }
      });
    }
  };

  useEffect(() => {

    monthlyLoadComp();
    // console.log("rvsgvs");
    // let payable_amount = monthlyComponentAmount;

    // if (monthlyComponentCGSTRate > 0 && monthlyComponentSGSTRate > 0 && monthlyComponentAmount > 0) {
    //   cgst_amount = (parseFloat(monthlyComponentAmount) * parseFloat(monthlyComponentCGSTRate)) / 100;
    //   sgst_amount = (parseFloat(monthlyComponentAmount) * parseFloat(monthlyComponentSGSTRate)) / 100;
    //   total_gst_amt = cgst_amount + sgst_amount;
    //   payable_amount = monthlyComponentAmount + total_gst_amt;
    // }

  }, [isMonthlyComponentRender]);


  const [discountAmount, setDiscountAmount] = useState(0);
  const monthlyLoadComp = ({ paidtAmount = 0 } = {}) => {
    let obj = [];

    let sortAmount = form.getFieldValue("adjust_amount");
    let paid_amount = paidtAmount - sortAmount;
    let monthly_total_discount = form.getFieldValue("component_details_monthly");
    // console.log("monthly_total_discount", monthly_total_discount);
    let i = 1;
    if (form.getFieldValue('mode') == "ADD") {
      progCommercialCompMonthlyList.map((e, index) => {
        let discount = monthly_total_discount[index]?.discount !== undefined
          ? monthly_total_discount[index].discount
          : 0;
        let is_waiver = monthly_total_discount[index]?.is_waiver !== undefined
          ? monthly_total_discount[index].is_waiver
          : "N";
        let cgst_amount = 0;
        let sgst_amount = 0;
        let total_gst_amt = 0;
        let amount = 0;
        if (is_waiver == "N") {
          amount = e.amount;
        }

        // console.log("ascdghasdcv", progCommercialCompMonthlyList);

        let payable_amount = e.amount - discount;
        let monthlyDueAmount = 0;
        if (is_waiver == "N") {
          paid_amount = paid_amount - payable_amount
          if (paidtAmount > 0 && paid_amount < 0) {
            monthlyDueAmount = paid_amount;
            if (i > 1) {
              monthlyDueAmount = payable_amount;
            }
            i++;
          }
        }
        if (monthlyComponentCGSTRate > 0 && monthlyComponentSGSTRate > 0 && e.amount > 0) {
          cgst_amount = (parseFloat(e.amount) * parseFloat(monthlyComponentCGSTRate)) / 100;
          sgst_amount = (parseFloat(e.amount) * parseFloat(monthlyComponentSGSTRate)) / 100;
          total_gst_amt = cgst_amount + sgst_amount;
          payable_amount = e.amount + total_gst_amt;
        }

        const x = {
          component_id: monthlyComponentID,
          description: e.month_year,
          month_id: e.month_id,
          year: e.year,
          cr_ac_id: setAcountId,
          amount: is_waiver == 'Y' ? 0 : e.amount,
          discount: is_waiver == 'Y' ? 0 : discount,
          taxable_amount: is_waiver == 'Y' ? 0 : e.amount - discount,
          cgst_id: monthlyComponentCGSTID,
          cgst_rate: is_waiver == 'Y' ? 0 : monthlyComponentCGSTRate,
          cgst_rate_text: is_waiver == 'Y' ? `${0}%` : `${monthlyComponentCGSTRate}%`,
          cgst_amount: is_waiver == 'Y' ? 0 : cgst_amount,
          sgst_id: monthlyComponentSGSTID,
          sgst_rate: is_waiver == 'Y' ? 0 : monthlyComponentSGSTRate,
          sgst_rate_text: is_waiver == 'Y' ? `${0}%` : `${monthlyComponentSGSTRate}%`,
          sgst_amount: is_waiver == 'Y' ? 0 : sgst_amount,
          total_gst_amount: is_waiver == 'Y' ? 0 : total_gst_amt,
          net_amount: is_waiver == 'Y' ? 0 : payable_amount,
          due_amount: is_waiver == 'Y' ? 0 : Math.abs(monthlyDueAmount),
          is_due: is_waiver == 'Y' ? 'N' : monthlyDueAmount !== 0 ? "Y" : "N",
          is_waiver: is_waiver
        };
        // console.log("monthlyDueAmount", monthlyDueAmount);
        obj.push(x);
      });

      form.setFieldsValue({ component_details_monthly: obj });
    }
    onFormCalculation();
  }


  useEffect(() => {
    accountService.accountList().then((res) => {
      setAccountList(res.data.response_data);
    });
  }, []);





  const onFormCalculation = () => {
    setIsFormChanged(false)
    let resultCGST = [];
    let resultSGST = [];


    // Admission
    let admission_total_amount = form.getFieldValue("component_details_admission").reduce((total, obj) => parseFloat(obj.amount) + total, 0);
    let admission_total_discount = form.getFieldValue("component_details_admission").reduce((total, obj) => parseFloat(obj.discount) + total, 0);
    let admission_total_taxable = form.getFieldValue("component_details_admission").reduce((total, obj) => parseFloat(obj.taxable_amount) + total, 0);
    let admission_total_cgst_amount = form.getFieldValue("component_details_admission").reduce((total, obj) => parseFloat(obj.cgst_amount) + total, 0);
    let admission_total_sgst_amount = form.getFieldValue("component_details_admission").reduce((total, obj) => parseFloat(obj.sgst_amount) + total, 0);


    form.getFieldValue("component_details_admission").reduce(function (res, value) {
      if (!res[value.cgst_id]) {
        res[value.cgst_id] = { gst_id: value.cgst_id, amount: 0, cgst_rate: value.cgst_rate };
        resultCGST.push(res[value.cgst_id])
      }
      res[value.cgst_id].amount += value.cgst_amount;
      return res;
    }, {});


    form.getFieldValue("component_details_admission").reduce(function (res, value) {
      if (!res[value.sgst_id]) {
        res[value.sgst_id] = { gst_id: value.sgst_id, amount: 0, sgst_rate: value.sgst_rate };
        resultSGST.push(res[value.sgst_id])
      }
      res[value.sgst_id].amount += value.sgst_amount;
      return res;
    }, {});




    // Monthly
    let monthly_total_amount = form.getFieldValue("component_details_monthly").reduce((total, obj) => parseFloat(obj.amount) + total, 0);
    let monthly_total_discount = form.getFieldValue("component_details_monthly").reduce((total, obj) => parseFloat(obj.discount) + total, 0);
    let monthly_total_taxable = form.getFieldValue("component_details_monthly").reduce((total, obj) => parseFloat(obj.taxable_amount) + total, 0);
    let monthly_total_cgst_amount = form.getFieldValue("component_details_monthly").reduce((total, obj) => parseFloat(obj.cgst_amount) + total, 0);
    let monthly_total_sgst_amount = form.getFieldValue("component_details_monthly").reduce((total, obj) => parseFloat(obj.sgst_amount) + total, 0);
    let monthly_total_due_amount = form.getFieldValue("component_details_monthly").reduce((total, obj) => parseFloat(obj.due_amount) + total, 0);

    //let resultCGST_Monthly = [];
    form.getFieldValue("component_details_monthly").reduce(function (res, value) {
      if (!res[value.cgst_id]) {
        res[value.cgst_id] = { gst_id: value.cgst_id, amount: value.cgst_amount, cgst_rate: value.cgst_rate };
        //resultCGST_Monthly.push(res[value.cgst_id])
        resultCGST.push(res[value.cgst_id])
      }
      res[value.cgst_id].amount += value.cgst_amount;
      return res;
    }, {});

    //let resultSGST_Monthly = [];
    form.getFieldValue("component_details_monthly").reduce(function (res, value) {
      if (!res[value.sgst_id]) {
        res[value.sgst_id] = { gst_id: value.sgst_id, amount: value.sgst_amount, sgst_rate: value.sgst_rate };
        resultSGST.push(res[value.sgst_id])
      }
      res[value.sgst_id].amount += value.sgst_amount;
      return res;
    }, {});




    // Others
    let others_total_amount = form.getFieldValue("component_details_others").reduce((total, obj) => parseFloat(obj.amount) + total, 0);
    let others_total_discount = form.getFieldValue("component_details_others").reduce((total, obj) => parseFloat(obj.discount) + total, 0);
    let others_total_taxable = form.getFieldValue("component_details_others").reduce((total, obj) => parseFloat(obj.taxable_amount) + total, 0);
    let others_total_cgst_amount = form.getFieldValue("component_details_others").reduce((total, obj) => parseFloat(obj.cgst_amount) + total, 0);
    let others_total_sgst_amount = form.getFieldValue("component_details_others").reduce((total, obj) => parseFloat(obj.sgst_amount) + total, 0);


    //let resultCGST_Others = [];
    form.getFieldValue("component_details_others").reduce(function (res, value) {
      if (!res[value.cgst_id]) {
        res[value.cgst_id] = { gst_id: value.cgst_id, amount: value.cgst_amount, cgst_rate: value.cgst_rate };
        resultCGST.push(res[value.cgst_id])
      }
      res[value.cgst_id].amount += value.cgst_amount;
      return res;
    }, {});




    //let resultSGST_Others = [];
    form.getFieldValue("component_details_others").reduce(function (res, value) {

      if (!res[value.sgst_id]) {
        res[value.sgst_id] = { gst_id: value.sgst_id, amount: value.sgst_amount, sgst_rate: value.sgst_rate };
        resultSGST.push(res[value.sgst_id])
      }
      res[value.sgst_id].amount += value.sgst_amount;
      return res;
    }, {});



    // let total_amount =  parseFloat(commonUtility.sanitizeValue(monthly_total_amount)) + parseFloat(commonUtility.sanitizeValue(others_total_amount));
    // let total_discount = parseFloat(commonUtility.sanitizeValue(monthly_total_discount)) + parseFloat(commonUtility.sanitizeValue(others_total_discount));
    // let total_taxable = parseFloat(commonUtility.sanitizeValue(monthly_total_taxable)) + parseFloat(commonUtility.sanitizeValue(others_total_taxable));
    // let total_cgst_amount = parseFloat(commonUtility.sanitizeValue(monthly_total_cgst_amount)) + parseFloat(commonUtility.sanitizeValue(others_total_cgst_amount));
    // let total_sgst_amount = parseFloat(commonUtility.sanitizeValue(monthly_total_sgst_amount)) + parseFloat(commonUtility.sanitizeValue(others_total_sgst_amount));
    // let total_payable_amount = parseFloat(commonUtility.sanitizeValue(total_taxable)) + parseFloat(commonUtility.sanitizeValue(total_cgst_amount)) + parseFloat(commonUtility.sanitizeValue(total_sgst_amount));


    let total_amount = parseFloat(commonUtility.sanitizeValue(admission_total_amount)) + parseFloat(commonUtility.sanitizeValue(monthly_total_amount)) + parseFloat(commonUtility.sanitizeValue(others_total_amount));
    let total_discount = parseFloat(commonUtility.sanitizeValue(admission_total_discount)) + parseFloat(commonUtility.sanitizeValue(monthly_total_discount)) + parseFloat(commonUtility.sanitizeValue(others_total_discount));
    let total_taxable = parseFloat(commonUtility.sanitizeValue(admission_total_taxable)) + parseFloat(commonUtility.sanitizeValue(monthly_total_taxable)) + parseFloat(commonUtility.sanitizeValue(others_total_taxable));
    let total_cgst_amount = parseFloat(commonUtility.sanitizeValue(admission_total_cgst_amount)) + parseFloat(commonUtility.sanitizeValue(monthly_total_cgst_amount)) + parseFloat(commonUtility.sanitizeValue(others_total_cgst_amount));
    let total_sgst_amount = parseFloat(commonUtility.sanitizeValue(admission_total_sgst_amount)) + parseFloat(commonUtility.sanitizeValue(monthly_total_sgst_amount)) + parseFloat(commonUtility.sanitizeValue(others_total_sgst_amount));

    let short_access_amount = form.getFieldValue("adjust_amount") != undefined && form.getFieldValue("adjust_amount") != null && form.getFieldValue("adjust_amount") != "" ? parseFloat(form.getFieldValue("adjust_amount")) : 0;


    let total_payable_amount = parseFloat(commonUtility.sanitizeValue(total_taxable)) + parseFloat(commonUtility.sanitizeValue(total_cgst_amount)) + parseFloat(commonUtility.sanitizeValue(total_sgst_amount)) + short_access_amount;

    /*
    form.setFieldsValue({
      payable_amount: total_payable_amount.toFixed(2)
    });
    */

    const payableAmountDetail = commonUtility.getRoundOfAmount(total_payable_amount);
    //console.log("payableAmountDetail",payableAmountDetail)
    const new_payable_amount = payableAmountDetail.newPayableAmount;
    const roundoff_amount = payableAmountDetail.roundoffAmount;

    form.setFieldsValue({
      payable_amount: new_payable_amount,
      round_off_amount: roundoff_amount
    });


    //console.log("Paid S Amount",getRoundOfAmount(total_payable_amount))




    setTotalAmount(total_amount.toFixed(2))
    setTotalDiscountAmount(total_discount.toFixed(2))
    setTotalTaxableAmount(total_taxable.toFixed(2))
    setTotalCGSTAmount(total_cgst_amount.toFixed(2))
    setTotalSGSTAmount(total_sgst_amount.toFixed(2))
    setTotalNetAmount(total_payable_amount.toFixed(2))
    setTotalPayableAmount(new_payable_amount.toFixed(2))

    setTotalRoundOff(0)
    if (roundoff_amount) {
      setTotalRoundOff(`${roundoff_amount}`)
    }
    setIsFormChanged(true)
  }

  /*
    useEffect(() => {
      onFormCalculation();
    }, [form,state.otheritem]);
    */

  useEffect(() => {
    onFormCalculation();
  }, [state.otheritem]);




  // const getRoundOfAmount = (amount) => {
  //   let roundOffDetail = {}
  //   const reminder = amount%10;

  //   if(reminder>=0 && reminder<5){
  //     const newPayableAmt = amount-reminder;
  //     roundOffDetail = {
  //       "roundoffAmount" : reminder,
  //       "newPayableAmount" : newPayableAmt,
  //       "operation" : "-"
  //     }
  //   }
  //   else if(reminder>=5 && reminder<=9){
  //     const roundOffAmount = 10-reminder;
  //     const newPayableAmt = amount+roundOffAmount;

  //     roundOffDetail = {
  //       "roundoffAmount" : roundOffAmount,
  //       "newPayableAmount" : newPayableAmt,
  //       "operation" : "+"
  //     }
  //   }

  //   return roundOffDetail
  // }


  // Payment mode Data 
  const [isPaymentModeDisabled, setIsPaymentModeDisabled] = useState(false);
  const [enrollmentDueAmount, setEnrollmentDueAmount] = useState(0);
  const [enrollmentError, setEnrollmentError] = useState("");
  const [isPaidAmountValids, setIsPaidAmountValids] = useState(false);

  // console.log("enrollmentDueAmount", enrollmentDueAmount);
  const [shoertAmount, setShortAmount] = useState(0);
  const [removeShortAmount, setRemoveShortAmount] = useState(true);

  const addPaymentMode = () => {
    // const paid_monthly_amount = form.getFieldValue('paid_amount');
    const no_of_months = form.getFieldValue("no_of_months")
    const selected_payment_mode_text = form.getFieldValue('selected_payment_mode_text');
    const mode = form.getFieldValue('selected_payments_mode');
    // const paid_amount = paidAmount;
    const paid_amount = form.getFieldValue('paid_amount');
    const dr_account_id = form.getFieldValue('dr_account_id');
    const cheque_no = form.getFieldValue('cheque_no');
    const cheque_date = form.getFieldValue('cheque_date');
    const total_payable_amount = form.getFieldValue('payable_amount');
    const bank = form.getFieldValue('bank');
    const branch = form.getFieldValue('branch');
    const bank_charges = commonUtility.sanitizeValue(form.getFieldValue('bank_charges'));
    const payment_ref = form.getFieldValue('payment_ref');
    // console.log(form);

    // console.log("paid_amount", paid_amount);

    let bank_charges_amount = 0;
    if (commonUtility.sanitizeValue(bank_charges) > 0) {
      bank_charges_amount = (parseFloat(paid_amount) * parseFloat(bank_charges)) / 100;
      bank_charges_amount = Math.round(bank_charges_amount);
    }

    monthlyLoadComp({ paidtAmount: paid_amount });

    let returnStatement = false;
    let isMonthAdjustNotification = false;
    let tt_payable_amount = 0;
    // let component = form.getFieldValue("component_details_monthly");
    // component.map((month) => {

    //   const payable_amount = month.amount - month.discount;
    //   tt_payable_amount += payable_amount;
    //   const due_amount = month.due_amount;
    //   console.log(month.amount);
    //   if (month.is_waiver == "N" && due_amount >= payable_amount) {
    //     setIsPaidAmountValids(true);
    //     isMonthAdjustNotification = true;

    //     returnStatement = true;
    //   } else {
        setIsPaymentModeDisabled(false);
    //     setIsPaidAmountValids(false);
    //   }
    // });

    // if (paid_amount > total_payable_amount) {
    //   setIsPaidAmountValids(true);
    //   commonUtility.openNotificationWithType(
    //     "error",
    //     "topRight",
    //     "Validation Error",
    //     "You are not able to pay greater then payable amount"
    //   );
    //   returnStatement = true;
    // }

// for remove validation of due amount > monthly amount 17/09/2024 //
    // if (isMonthAdjustNotification) {
    //   commonUtility.openNotificationWithType(
    //     "error",
    //     "topRight",
    //     "Validation Error",
    //     "Remove the month to adjust the payment"
    //   );
    // }

    if (returnStatement) {
      return;
    }



    // monthlyLoadComp({ paidtAmount: paid_amount });

    if (commonUtility.sanitizeObject(selected_payment_mode_text) && commonUtility.sanitizeObject(mode) && commonUtility.sanitizeValue(paid_amount) >= 0) {
      let amount = parseFloat(paid_amount) + parseFloat(bank_charges_amount);



      setPaymentPaidList([...paymentPaidList, {
        rowKey: commonUtility.randomID(),
        mode_description: selected_payment_mode_text,
        payment_mode_text: selected_payment_mode_text,
        payment_mode_id: mode,
        payment_mode: mode,
        dr_account_id: dr_account_id,
        amount: amount,
        paid_amount: paid_amount,
        cheque_no: cheque_no,
        cheque_date: cheque_date,
        bank_name: bank,
        bank_branch: branch,
        bank_charges: bank_charges_amount,
        payment_ref: payment_ref,
      }]);

      setIsPaymentModeDisabled(true);


      form.setFieldsValue({
        selected_payment_mode_text: "",
        selected_payments_mode: "",
        cheque_no: "",
        cheque_date: "",
        bank: "",
        payment_ref: "",
      });
      setIsOtherComponentRender(false);
    } else {
      commonUtility.openNotificationWithType(
        "error",
        "bottomRight",
        "Error",
        PAYMENT_SECTION_REQUIRED_MESSAGE
      );
      return;
    }

    // for shoert access amount set as adjustment_amount not 0  17/09/2024 //
    // let shortsAmount = form.getFieldValue("adjust_amount");

    // if (removeShortAmount) {
    //   setShortAmount(shortsAmount);
    // }

    // if (shortsAmount > 0) {
    //   form.setFieldsValue({ adjust_amount: adjust_amount });
    // } else {
    //   form.setFieldsValue({ adjust_amount: shortsAmount });
    // }
  };




  // Remove payment Mode
  const removePayment = (index) => {
    const list = [...paymentPaidList];
    list.splice(index, 1);
    setPaymentPaidList(list);

    if (list.length === 0) {
      setIsPaymentModeDisabled(false);
    }
    let shortsAmount = form.getFieldValue("adjust_amount"); 
    if(shoertAmount > 0){
      setRemoveShortAmount(true);
      form.setFieldsValue({ adjust_amount: shoertAmount });
    }
    setPaidAmount(0);
    monthlyLoadComp();
  }


  useEffect(() => {
    setRemainingAmount(parseFloat(totalPayableAmount) + parseFloat(totalBankCharges) - parseFloat(totalPaidAmount))
  }, [totalPayableAmount, totalPaidAmount])







  /***************************************ADD MODE***************************/
  /***************************************ADD MODE***************************/
  /***************************************ADD MODE***************************/
  useEffect(() => {
    form.resetFields();
    resetState();
    //form.setFieldsValue({mode:"ADD"});

    setEnrollmentID(params.enrollmentid);
    setReceiptID(params.receiptid);
    setPaymentID(params.paymentid);
    // console.log(params);

    if (params.memberid) {
      onSelectMember(params.memberid)
      setMemberID(params.memberid);
      setIsMemberEditable(false)
      //form.setFieldsValue({mode:"EDIT"});
    }

    if (params.billtype) {
      setBillType(params.billtype)
      const isGST = params.billtype == "gst" ? "Y" : "N";
      form.setFieldsValue({
        is_gst_bill: isGST
      });
      setGSTBillType(isGST);
    }

    //window.location.reload();


  }, [params])

  useEffect(() => {
    onSelectMember(memberID)
  }, [programmeID, memberID]);




  /** ****************************************************************************
   * ******************************* Edit Mode ***********************************
   * *****************************************************************************
   */





  /**
   * Set Master Data Programme Edit Mode
   */


  useEffect(() => {
    if (enrollmentID > 0 && receiptID > 0) {
      const data = {
        formdata: {
          enrollment_id: enrollmentID,
        },
      };
      enrollmentService.JCPenrollmentDatabyID(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          const enrollment_data = res.data.response_data[0];

          //setProgrammeID(enrollment_data.programme_id);
          setProgrammeID(JCP_PROGRAM_ID);
          setProgrammeGroupID(enrollment_data.group_id);

          form.setFieldsValue({
            mode: "EDIT",
            enrollment_id: enrollmentID,
            member_search: `${enrollment_data.member_fname} ${enrollment_data.member_lname}`,
            member_id: enrollment_data.member_id,
            member_name: `${enrollment_data.member_fname} ${enrollment_data.member_lname}`,
            member_primary_mobile: enrollment_data.primary_mobile,
            member_father_name: enrollment_data.father_name != null && enrollment_data.father_name != "" ? enrollment_data.father_name : '',
            date_of_birth: enrollment_data.date_of_birth,
            programme_id: enrollment_data?.programme_id,
            group_id: enrollment_data?.group_id,
            join_date: enrollment_data.enrollment_date != null && enrollment_data.enrollment_date != "" ? moment(enrollment_data.enrollment_date, DATE_FORMAT_DMY_SLASH) : '',
            date_of_join: enrollment_data.enrollment_date,
            enrollment_start_date: enrollment_data.enrollment_start_date,
            enrollment_end_date: enrollment_data.enrollment_end_date,
          })


          setMemberDisplayInfo({
            memberName: `${enrollment_data.member_fname} ${enrollment_data.member_lname}`,
            memberPrimaryMobile: enrollment_data.primary_mobile,
            memberFatherName: enrollment_data.father_name != null && enrollment_data.father_name != "" ? enrollment_data.father_name : '',
            memberDOB: enrollment_data.date_of_birth,
            profilePic: enrollment_data.profile_picture,
          });




          setMemberDisplayOtherInfo({
            group: enrollment_data.group_id === 1 ? 'Morning' : enrollment_data.group_id === 2 ? 'Afternoon' : 'Evening',
            joinDate: enrollment_data.enrollment_date,
            validity: `${enrollment_data.enrollment_start_date} to ${enrollment_data.enrollment_end_date}`
          });

          setIsMemberEditable(false)
          monthlyComponentGenerate();
          setIsPaymentModeDisabled(true);
        }
      });
    }
  }, [enrollmentID]);



  /**
   * Set Total Payment Amount Data 
   */
  useEffect(() => {
    if (receiptID > 0) {
      const data = {
        formdata: {
          receipt_id: receiptID,
        },
      };
      enrollmentService.JCPReceiptDatabyID(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {


          setTotalAmount(0)
          setTotalDiscountAmount(0)
          setTotalTaxableAmount(0)
          setTotalCGSTAmount(0)
          setTotalSGSTAmount(0)
          setTotalNetAmount(0)
          setTotalPayableAmount(0)


          const receipt_data = res.data.response_data[0];
          // console.warn(receipt_data);

          setShortAdjustmentData({
            adjust_receipt_id: receipt_data.adjust_receipt_id,
            adjust_amount: receipt_data.adjust_amount,
          });

          form.setFieldsValue({
            mode: "EDIT",
            no_of_months: receipt_data.no_of_months,
            receipt_id: receipt_data.receipt_id,
            receipt_no: receipt_data.receipt_no,
            receipt_date: receipt_data.receipt_date,
            receipt_date_input: receipt_data.receipt_date != null && receipt_data.receipt_date != "" ? moment(receipt_data.receipt_date, DATE_FORMAT_DMY_SLASH) : '',
            dr_ac_id: receipt_data.dr_ac_id,
            entry_from: receipt_data.entry_from,
            adjust_receipt_id: receipt_data.adjust_receipt_id,
            adjust_amount: receipt_data.adjust_amount,
          })


          setTotalAmount(receipt_data.total_amount.toFixed(2))
          setTotalDiscountAmount(receipt_data.total_discount.toFixed(2))
          setTotalTaxableAmount(receipt_data.total_taxable_amount.toFixed(2))
          setTotalCGSTAmount(receipt_data.total_cgst_amount.toFixed(2))
          setTotalSGSTAmount(receipt_data.total_sgst_amount.toFixed(2))

          const total_net_amount = receipt_data.total_taxable_amount + receipt_data.total_cgst_amount + receipt_data.total_sgst_amount

          setTotalNetAmount(total_net_amount.toFixed(2))
          setTotalPayableAmount(receipt_data.net_payble_amount.toFixed(2))
        }
      });
    }
  }, [receiptID]);








  useEffect(() => {
    if (receiptID > 0 && enrollmentID > 0) {

      //setIsAdmissionComponentRender(false)
      const dataAdm = {
        formdata: {
          receipt_id: receiptID,
          component_type: "ADMISSION",
        },
      };

      enrollmentService.componentDetailsAgainstReceipt(dataAdm).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          const admission_component_details = res.data.response_data;

          // console.log('admission_component_details', admission_component_details);
          if(admission_component_details[0].is_security == 'Y') setMonthlyComponentShow(false);
          let obj = [];
          admission_component_details.map((e) => {
            const x = {
              component_id: e.component_id,
              description: e.description,
              month_id: e.month_id,
              year: e.year,
              amount: e.amount,
              cr_ac_id: e.cr_ac_id,
              discount: e.discount,
              taxable_amount: e.taxable_amount,
              cgst_id: e.cgst_id,
              cgst_rate: e.cgst_rate,
              cgst_rate_text: `${commonUtility.sanitizeValue(e.cgst_rate)}%`,
              cgst_amount: e.cgst_amount,
              sgst_id: e.sgst_id,
              sgst_rate: e.sgst_rate,
              sgst_rate_text: `${commonUtility.sanitizeValue(e.sgst_rate)}%`,
              sgst_amount: e.sgst_amount,
              total_gst_amount: e.total_gst_amount,
              net_amount: e.net_amount,
              is_security: e.is_security,
            };
            obj.push(x);
          });

          form.setFieldsValue({ component_details_admission: obj });
          //setIsAdmissionComponentRender(true)
        }
      });



      const data = {
        formdata: {
          receipt_id: receiptID,
          component_type: "MONTHLY",
        },
      };

      enrollmentService.componentDetailsAgainstReceipt(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          const monthly_component_details = res.data.response_data;
          let obj = [];
          monthly_component_details.map((e) => {
            const x = {
              component_id: e.component_id,
              description: e.description,
              month_id: e.month_id,
              year: e.year,
              amount: e.amount,
              cr_ac_id: e.cr_ac_id,
              discount: e.discount,
              taxable_amount: e.taxable_amount,
              cgst_id: e.cgst_id,
              cgst_rate: e.cgst_rate,
              cgst_rate_text: `${commonUtility.sanitizeValue(e.cgst_rate)}%`,
              cgst_amount: e.cgst_amount,
              sgst_id: e.sgst_id,
              sgst_rate: e.sgst_rate,
              sgst_rate_text: `${commonUtility.sanitizeValue(e.sgst_rate)}%`,
              sgst_amount: e.sgst_amount,
              total_gst_amount: e.total_gst_amount,
              net_amount: e.net_amount,
              due_amount: e.due_amount,
              is_security: e.is_security,
            };
            obj.push(x);
          });

          form.setFieldsValue({ component_details_monthly: obj });

        }
      });
    }
  }, [enrollmentID, receiptID]);



  useEffect(() => {
    if (receiptID > 0 && enrollmentID > 0) {
      const data = {
        formdata: {
          receipt_id: receiptID,
          component_type: "OTHERS",
        },
      };

      enrollmentService.componentDetailsAgainstReceipt(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          setProgCommercialCompOtherListInitialValue([]);



          const other_component_details = res.data.response_data;
          let obj = [];
          setProgCommercialCompOtherListInitialValue(other_component_details);
        }
      });
    }
  }, [enrollmentID, receiptID]);




  /**
   * payment Info && Payment List Detail
   */

  useEffect(() => {
    if (receiptID > 0 && enrollmentID > 0 && paymentID > 0) {

      const data = {
        formdata: {
          payment_id: paymentID,
        },
      };
      paymentService.paymentmasterDataByID(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {

          setTotalPaidAmount(0)
          setTotalRoundOff(0)

          const payment_data = res.data.response_data[0];
          form.setFieldsValue({
            mode: "EDIT",
            payment_id: payment_data.payment_id,
            payment_date: payment_data.payment_date,
            date_of_payment: payment_data.payment_date ? moment(payment_data.payment_date, DATE_FORMAT_DMY_SLASH) : '',
            payment_no: payment_data.payment_no,
            student_account_id: payment_data.short_excess_cr_ac_id,
            member_opening_balance: payment_data.short_excess_amount,
            payment_amount: payment_data.payment_amount,
            voucher_id: payment_data.voucher_id,
            payable_amount: payment_data.total_payble_amount,
            round_off_amount: payment_data.round_off_amount,
            round_off_account_id: payment_data.round_off_account_id,
          })

          setTotalPaidAmount(payment_data.payment_amount.toFixed(2))
          setTotalRoundOff(payment_data.round_off_amount)
          setReceiptHistoryList(payment_data);

        }
      });


    }
  }, [paymentID])


  useEffect(() => {
    if (receiptID > 0 && enrollmentID > 0 && paymentID > 0) {

      const data = {
        formdata: {
          payment_id: paymentID,
        },
      };






      paymentService.paymentDetailsDataByID(data).then((res) => {
        // console.log("PaymentDetailList0123 ",res.data.response_data) 
        if (res.data.response_status === SUCCESS_STATUS) {

          let payment_list = res.data.response_data;
          const newData = payment_list.map(details => {
            return { ...details }
          });
          setPaymentPaidList(newData);
        }
      });

      getMemberNextPaymentMonth(enrollmentID, receiptID)

    }
  }, [receiptID, paymentID])

  useEffect(() => {
    /*
    const total_paid_amount = paymentPaidList.reduce((a, v) => a = a + parseFloat(v.amount), 0);
    setTotalPaidAmount(parseFloat(commonUtility.sanitizeValue(total_paid_amount).toFixed(2)))
    form.setFieldsValue({
      payment_amount: total_paid_amount.toFixed(2)
    })
    */

    const total_paid_amount = paymentPaidList.reduce((a, v) => a = a + parseFloat(v.amount), 0);
    const total_bank_charges = paymentPaidList.reduce((a, v) => a = a + parseFloat(v.bank_charges), 0);

    setTotalBankCharges(parseFloat(commonUtility.sanitizeValue(total_bank_charges)).toFixed(2))
    setTotalPaidAmount(parseFloat(commonUtility.sanitizeValue(total_paid_amount)).toFixed(2))

    form.setFieldsValue({
      payment_amount: total_paid_amount.toFixed(2),
      total_bank_charges: total_bank_charges,
    })

  }, [paymentPaidList, receiptID, paymentID])



  const getMemberNextPaymentMonth = (enrollmentId, receiptId) => {

    const data = {
      formdata: {
        enrollment_id: enrollmentId,
        mode: 'EDIT',
        receipt_id: receiptId
      },
    };
    ProgrammeService.memberLastMonthPayment(data).then((res) => {
      const response = res.data.response_data[0];
console.log("resposneEdit", response);


      if (res.data.response_status === SUCCESS_STATUS) {
        setLastPaidMonthHistoryText("");
        form.setFieldsValue({
          date_of_join: response?.nexy_pay_month
        });
        setLastPaidMonthHistoryText(response?.last_paid_date)
        form.setFieldsValue({
          last_paid_date: response?.last_paid_date
        });
      }


    });
  }

  const handleCancel = () => {
    setOpenModal(false);
  };
  function changeLocation(placeToGo) {
    navigate(placeToGo, { replace: true });
    window.location.reload();
  }


  const resetState = () => {
    setEnrollmentID(0);
    setReceiptID(0);
    setPaymentID(0);
    setMemberID(0);
    setBillType("");
    setGSTBillType("");


    //setProgrammeGroupList([]);
    //setMemberList([]);
    setIsAlreadyMemberEnrolled(false);
    setAlreadyMemberEnrolledMessage("");


    setProgCommercialCompMonthlyList([]);
    setProgCommercialCompOtherList([]);
    setProgCommercialCompOtherListInitialValue([]);



    //setProgrammeID([]);
    setProgrammeGroupID(0);

    setMonthlyComponentID(0);
    setMonthlyComponentAmount(0);
    setMonthlyComponentAccountID(0);
    setMonthlyComponentDesc("");

    setMonthlyComponentCGSTID(0);
    setMonthlyComponentCGSTRate(0);
    setMonthlyComponentSGSTID(0);
    setMonthlyComponentSGSTRate(0);

    setIsMonthlyComponentRender(false);
    setIsOtherComponentRender(false);
    //setAccountList([]);
    setIsFormChanged(false);

    setTotalAmount(0);
    setTotalDiscountAmount(0);
    setTotalTaxableAmount(0);
    setTotalCGSTAmount(0);
    setTotalSGSTAmount(0);
    setTotalPayableAmount(0);
    setTotalNetAmount(0);
    setTotalRoundOff(0);
    setTotalBankCharges(0);



    // Payment useState
    setPaymentPaidList([]);
    setTotalPaidAmount(0);
    setRemainingAmount(0);

    setSaveLoaderEnable(false);

    setOpenModal(false);
    setResponseModalTitle("");
    setResponseModalMessage("");

    setLastPaidMonthHistoryText("");

    // member Info
    setMemberDisplayInfo({
      memberName: '',
      memberPrimaryMobile: '',
      memberFatherName: '',
      memberDOB: '',
      profilePic: '',

    })

    setMemberDisplayOtherInfo({
      group: '',
      joinDate: '',
      validity: ''
    })

  }

  const resetFormFields = () => {
    const defaultFormValues = {
      mode: "ADD",
      enrollment_id: 0,
      member_id: 0,
      programme_id: 0,
      group_id: "",
      voucher_id: 0,
      date_of_join: null,
      enrollment_start_date: null,
      enrollment_end_date: null,
      dr_ac_id: "",
      student_account_id: MEMBER_ACCOUNT_ID,
      member_opening_balance: 0,
      last_paid_date: "",
      receipt_id: 0,
      receipt_no: "",
      receipt_date: null,
      is_payment_done: "N",
      no_of_months: 0,
      entry_from: "M",
      round_off_amount: 0,
      round_off_account_id: ROUND_OFF_ACCOUNT_ID,
      total_bank_charges: 0,
      bank_charges_account_id: BANK_CHARGES_ACCOUNT_ID,
      // day_slot: [],
      component_details_admission: [],
      component_details_monthly: [],
      component_details_others: [],
    };
  }
  
  return (
    <div className="form-input-style">
      <Row
        className="login-first-step-row"
        style={{ background: "transparent" }}
      >
        <Col className="form-format-type1 enrollment-form jcp-enrollment" xs={24} xl={24}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onJCPenrollmentSave}
            autoComplete="off"
            //initialValues={defaultValues}
            initialValues={defaultFormValues}
            onFieldsChange={(event) => onFormCalculation()}
            //onValuesChange={(event) => onFormCalculation()}
            onKeyUp={onFormCalculation}
            onBlur={onFormCalculation}
          >
            <Collapse
              bordered={false}
              defaultActiveKey={[
                "programme_jcp",
                "receipr_history_panel",
                "schedule_jcp",
                "receipt_jcp",
                "receipt_history_panel"

              ]}
              onChange={onChangeCollapse}
              expandIcon={({ isActive }) => (
                <CaretRightOutlined rotate={isActive ? 90 : 0} />
              )}
            >
              <Panel
                header={
                  <>
                    <h4>Programme</h4>
                  </>
                }
                key="programme_jcp"
                className="mainPanel"
              >
                <Row gutter={20}>
                  <Col xs={24} xl={12} >
                    <Row gutter={20}>
                      <Col className="gutter-row" xs={24} xl={24}>
                        <Form.Item
                          name="member_search"
                          label="Search (Name | Mobile no | Father Name)"
                          rules={[
                            {
                              required: true,
                              message: "Select Member / Student",
                            },
                          ]}
                        >
                          <Select
                            showSearch
                            placeholder="Search to Select"
                            optionFilterProp="children"
                            filterOption={(input, option) => {
                              const inputWords = input.trim().toLowerCase().split(/\s+/);
                              return inputWords.every(word =>
                                option.children.toLowerCase().includes(word)
                              );
                            }}
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                            onSelect={(value, event) => 
                              onSelectMember(value, event)
                            }
                            disabled={!isMemberEditable ? true : false}
                          >
                            {memberList.length > 0
                              ? memberList.map((member_list) => (
                                <Option
                                  key={`${member_list.member_id}_${Math.floor(Math.random() * 1000000)}`}
                                  value={member_list.member_id}
                                >
                                  {`${member_list.member_fname} ${member_list.member_lname
                                    } | ${member_list.primary_mobile}  ${member_list.father_name != null
                                      ? member_list.father_name
                                      : ""
                                    }`}
                                </Option>
                              ))
                              : ""}
                          </Select>
                        </Form.Item>
                        <Form.Item name="enrollment_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="mode" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="member_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="programme_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="voucher_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="entry_from" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="last_paid_date" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="is_security_paid" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="is_gst_bill" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="student_account_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="payment_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="receipt_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="payable_amount" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="round_off_amount" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="round_off_account_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item label="Bank Charge" name="total_bank_charges" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item label="Bank Charge" name="bank_charges_account_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="payment_amount" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        {/* <Form.Item name="dr_ac_id" hidden={true}>
                                            <Input type="text" />
                                        </Form.Item> */}
                      </Col>

                      <Col xs={24} xl={6} hidden={true}>
                        <Form.Item name="member_name" label="Name">
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={6} hidden={true}>
                        <Form.Item name="member_primary_mobile" label="Mobile">
                          <Input placeholder="" addonBefore="+91" readOnly={true} />
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={6} hidden={true}>
                        <Form.Item name="member_father_name" label="Father Name">
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                      </Col>
                      <Col className="gutter-row" xs={24} xl={6} hidden={true}>
                        <Form.Item name="date_of_birth" label="DOB">
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                        <Form.Item name="date_of_join" hidden={false}>
                          <Input type="text" readOnly={true} />
                        </Form.Item>
                      </Col>


                      {/* <Col className="gutter-row" xs={24} xl={12}>
                        <Form.Item name="join_date" label="Date of joining" rules={[
                          {
                            required: true,
                            message: "Date of joining is required",
                          },
                        ]} >
                           <Input type="text" readOnly={true} />
                        </Form.Item>
                        <Form.Item name="date_of_join" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                      </Col> */}

                      <Col xs={24} xl={6} hidden={true}>
                        <Form.Item
                          name="enrollment_start_date"
                          label="Programme Valid From"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={6} hidden={true}>
                        <Form.Item
                          name="enrollment_end_date"
                          label="Programme Valid To"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                      </Col>



                    </Row>

                    <Row gutter={20}>
                      <Col xs={24} xl={24}>
                        <StudentCardInfo memberDisplayInfo={memberDisplayInfo} memberDisplayOtherInfo={memberDisplayOtherInfo} />
                      </Col>
                    </Row>

                  </Col> {/** end of column */}

                  <Col xs={24} xl={12}>

                    {/* <Row gutter={20}>
                      <Col xs={24} xl={24}>
                        <StudentCardInfo memberDisplayInfo={memberDisplayInfo} memberDisplayOtherInfo={memberDisplayOtherInfo} />
                      </Col>
                    </Row> */}

                    <Row gutter={20}>
                      <ReceiptHistoryComponent
                        //receiptHistoryList = {receiptHistoryList}
                        enrollmentID={enrollmentID} memberID={memberID}
                        yearID={commonUtility.getLoggedInUserInfo()?.yearID}
                      />
                    </Row>

                  </Col>



                  <Col xs={24} xl={12}>
                    {isAlreadyMemberEnrolled ? (
                      <>
                        <Form.Item name="" label=" ">
                          <Alert
                            message={alreadyMemberEnrolledMessage}
                            type="error"
                          />
                        </Form.Item>
                      </>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>


              </Panel>

              {/* <Panel
                header={
                  <>
                    <h4>Receipt History</h4>
                  </>
                }
                key="receipt_history_panel"
                className="mainPanel"
              >
                <ReceiptHistoryComponent 
                enrollmentID = {enrollmentID}
                />
              </Panel> */}






              <Panel
                header={
                  <>
                    <h4>Receipt</h4>
                  </>
                }
                key="receipt_jcp"
                className="mainPanel"
              >

                <Collapse
                  defaultActiveKey={[
                    "admission_component_panel",
                    "monthly_component_panel",
                    "other_component_panel",
                    "member_payment_panel"
                  ]}
                  ghost
                >

                  {

                    // ((commonUtility.sanitizeObject(lastPaidMonthHistoryText) === "" && isGSTBill == "N") || (form.getFieldValue('mode') === EDIT_MODE && isGSTBill == "N")) && isParentEnrollment == "N" ? <>

                    ((((commonUtility.sanitizeObject(lastDatePaid) === "" && commonUtility.sanitizeObject(lastPaidMonth) === "") && isPaidSecurityInfo === "N") && isGSTBill == "N") || (form.getFieldValue('mode') === EDIT_MODE && isGSTBill == "N")) && isParentEnrollment == "N" ? <>
                      <Panel header="Admission / Security Deposit" key="admission_component_panel" className="admission-component-panel component-panel innerPanel" >
                        <EnrollmentComponent
                          enrollmentForm={form}
                          detailInputKey="component_details_admission"
                          onFormCalculation={onFormCalculation}
                          progCommercialCompMonthlyList={progCommercialCompMonthlyList}
                        //componentFor="ADMISSION"
                        />
                      </Panel>
                    </> : <></>
                  }




                  {
                    // mothly component panel show edit by dipten (12.02.2025)
                    monthlyComponentShow && monthlyComponentAmount > 0 ? <>

                      <Panel header="Monthly Payment" key="monthly_component_panel" className="monthly-component-panel component-panel innerPanel">
                        <Row gutter={20}>
                          <Col>
                            <p>Monthly Slots for </p>
                          </Col>
                          <Col>
                            <Form.Item name="no_of_months" label="">
                              <Input
                                placeholder="Enter month value"
                                onChange={(event, value) => {
                                  onChangeMonthlyMonth(event, value);
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col>
                            {
                              commonUtility.sanitizeObject(lastPaidMonthHistoryText) ? <>
                                <p>months <strong style={{ color: '#1a8811' }}>(You Paid upto {commonUtility.getMonthYearFromDate(lastPaidMonthHistoryText)})</strong> </p>
                              </> : <><p>months</p></>
                            }

                          </Col>
                        </Row>
                        {/* <EnrollmentComponent
                          enrollmentForm={form}
                          detailInputKey="component_details_monthly"
                          onFormCalculation={onFormCalculation}
                        /> */}


                        <EnrollmentComponent
                          progCommercialCompMonthlyList={progCommercialCompMonthlyList}
                          isMonthlyComponentRender={isMonthlyComponentRender}
                          enrollmentForm={form}
                          detailInputKey="component_details_monthly"
                          onFormCalculation={onFormCalculation}
                          onAmountChange={handleAmountChange}
                          // isMonthlyComponentRender={true}
                          dueAmount={enrollmentDueAmount}
                          setDiscountAmount={setDiscountAmount}
                          errorMessage={enrollmentError}
                        />

                      </Panel>




                    </> : <></>
                  }

                  <Panel header="Other Items" key="other_component_panel" className="other-component-panel component-panel innerPanel" style={{ display: isGSTBill == "Y" ? "block" : "none" }}>

                    <OtherItems
                      enrollmentForm={form}
                      detailInputKey="component_details_others"
                      initialValuesOtherItemList={progCommercialCompOtherListInitialValue}
                      onFormCalculation={onFormCalculation}
                      isGST={isGSTBill}
                    />

                  </Panel>






                  <Panel header="Receipt" key="member_payment_panel" className="member-payment component-panel innerPanel">

                    {
                      /**
                       * Payments Module
                       */
                    }

                    <PaymentComponent
                      enrollmentForm={form}
                      detailInputKey="component_payment"
                      addPaymentMode={addPaymentMode}
                      paymentPaidList={paymentPaidList}
                      removePayment={removePayment}
                      remainingAmount={remainingAmount}
                      isPaymentModeDisabled={isPaymentModeDisabled}

                      shortAdjustmentData={shortAdjustmentData}
                      monthlyLoadComp={monthlyLoadComp}
                      depositTrigger={isPaidSecurityInfo}
                      receiptHistoryList={receiptHistoryList}
                    />

                  </Panel>


                </Collapse>

                <div className="totalDetails">
                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text >Total Amount :  </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalAmount} </Text>
                    </Col>
                  </Row>
                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text >Total Discount :  </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalDiscountAmount} </Text>
                    </Col>
                  </Row>

                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text >Total Taxable :  </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalTaxableAmount} </Text>
                    </Col>
                  </Row>

                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text >Total CGST :  </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalCGSTAmount} </Text>
                    </Col>
                  </Row>

                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text >Total SGST :  </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalSGSTAmount} </Text>
                    </Col>
                  </Row>

                  <Row gutter={20} >
                    <Col xs={24} xl={20} align="right">
                      <Text >Total Net Amount :  </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalNetAmount} </Text>
                    </Col>
                  </Row>


                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text >Round Off :  </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalRoundOff} </Text>
                    </Col>
                  </Row>

                  {/* <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text italic>Total Payable :  </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalPayableAmount} </Text>
                    </Col>
                  </Row> */}


                  {/* -----Previous Code-------
                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text italic style={{fontSize: "18px", color: "#fb3b3b"}}>Total Payable = Amount to pay + Bank Charges(if any)  :  </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong style={{fontSize: "18px", color: "#fb3b3b"}}>{totalPayableAmount} + {totalBankCharges}</Text>
                    </Col>
                  </Row> */}


                  {/* New Changes on 02/04/24 =================Start Here*/}

                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text italic style={{ fontSize: "18px", color: "#fb3b3b" }}>Amount to pay :  </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong style={{ fontSize: "18px", color: "#fb3b3b" }}>{totalPayableAmount}</Text>
                    </Col>
                  </Row>
                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text italic style={{ fontSize: "18px", color: "#fb3b3b" }}>Bank Charges(if any) :  </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong style={{ fontSize: "18px", color: "#fb3b3b" }}>{totalBankCharges}</Text>
                    </Col>
                  </Row>
                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text italic style={{ fontSize: "18px", color: "#fb3b3b" }}>Total Payable :  </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong style={{ fontSize: "18px", color: "#fb3b3b" }}>{(Number(totalPayableAmount) + Number(totalBankCharges)).toFixed(2)}</Text>
                    </Col>
                  </Row>
                  {/* New Changes on 02/04/24 =================== Ends Here*/}


                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text italic style={{ fontSize: "18px", color: "#23910c" }}>Total Paid :  </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text style={{ fontSize: "18px", color: "#23910c" }}>{totalPaidAmount} </Text>
                    </Col>
                  </Row>

                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text > {remainingAmount < 0 ? "Excess" : "Short"} Amount :  </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{Math.abs(remainingAmount).toFixed(2)} </Text>
                    </Col>
                  </Row>
                </div>


                {/* <ModalWithMessageAndAction /> */}





                <Row justify="end">
                  <Col>
                    <Form.Item>
                      {
                        isSaveLoaderEnable ? <Spin /> : <>
                          <Button
                            htmlType="submit"
                            shape="round"
                            disabled={isAlreadyMemberEnrolled || hasAmountChanged || isPaidAmountValids}
                            className="custom-button-green"
                          >
                            Save <RightOutlined />
                          </Button>
                        </>
                      }


                    </Form.Item>
                  </Col>
                </Row>
              </Panel>
            </Collapse>
          </Form>
        </Col>
      </Row>




      <Modal
        title={responseModalTitle}
        centered
        visible={openModal}
        open={openModal}
        // onCancel={handleCancel}
        footer={[
          <a href={printURL} target="_blank" rel="noopener noreferrer">
            <Button htmlType="button" type="default"><PrinterOutlined /> Print</Button>
          </a>
          ,

          <Link to={`/jcp-reminder/`} style={{ margin: 1 }} >
            <Button htmlType="button" type="primary"> <EyeOutlined /> View List</Button>
          </Link>,

          <Link to={(`/jcp-monthly/${billType}`)}>
            {/* <Link to={`/jcp-monthly/`} onClick={() => changeLocation('/jcp-monthly')} style={{margin:1}} > */}
            <Button htmlType="button" type="danger"> <EyeOutlined /> Add More</Button>
          </Link>,

          // <Button key="submit" type="danger" onClick={()=> resetFormFields() }  style={{margin:1}} >
          //   <PlusOutlined /> Add More
          // </Button>,
        ]}
        style={{ width: '100px' }}
        className='responseModal'
      >
        <div style={{ textAlign: 'center' }}>
          <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '2.5rem' }} />
          <h3>{responseModalMessage}</h3>
        </div>

      </Modal>






    </div>
  );
};

export default JcpEnrollmentEntryMonthly;
